// extracted by css-extract-rspack-plugin
export default {"cls1":"useOverviewReadyToast-cls1_JJx","cls2":"useOverviewReadyToast-cls2_ZlK useOverviewReadyToast-cls1_JJx"};